import { render } from "./statistical-panel.vue?vue&type=template&id=0ff52dc2&scoped=true&ts=true"
import script from "./statistical-panel.vue?vue&type=script&lang=ts"
export * from "./statistical-panel.vue?vue&type=script&lang=ts"

import "./statistical-panel.vue?vue&type=style&index=0&id=0ff52dc2&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff52dc2"]])

export default __exports__